import { SortOption } from "../interfaces/hotel-page.interfacae";

export const HotelSortOptions: SortOption[] = [
    { value: "asc", label: "Low to high price", key: "price", code: "cheapest" },
    { value: "desc", label: "High to low price", key: "price", code: "expensive" },
    { value: "asc", label: "Low to high rating", key: "rating", code: "fair" },
    { value: "desc", label: "High to low rating", key: "rating", code: "good" }
];